/* globals localStorage */

export const getJWT = () => {
  return localStorage.getItem('jwt');
};

export const logout = () => {
  window.location = '/';
  localStorage.removeItem('jwt');
};

export const decodeJWT = token => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
};

export const getUserEmail = () => {
  try {
    const token = localStorage.getItem('jwt');
    if (!token) return null;
    const decoded = decodeJWT(token);
    return decoded.userEmail || null;
  } catch (error) {
    return null;
  }
};

export const isAuthenticated = () => {
  try {
    const token = localStorage.getItem('jwt');
    if (!token) return false;
    const decoded = decodeJWT(token);
    return decoded.exp > Date.now() / 1000;
  } catch (error) {
    return false;
  }
};

export const isAdmin = () => {
  try {
    const token = localStorage.getItem('jwt');
    if (!token) return false;
    const decoded = decodeJWT(token);
    return decoded.admin === true && !tokenHasExpired(decoded);
  } catch (error) {
    return false;
  };
};

export const tokenHasExpired = (decodedToken) => {
  try {
    const token = localStorage.getItem('jwt');
    if (!token) return false;
    const decoded = decodedToken || decodeJWT(token);
    return decoded.exp < Date.now() / 1000;
  } catch (error) {
    return false;
  }
};

export const canPostOnBB = () => {
  try {
    const token = localStorage.getItem('jwt');
    if (!token) return false;
    const decoded = decodeJWT(token);
    if (tokenHasExpired(decoded)) return false;
    if (decoded.admin) return true;
    return decoded.canPostOnBeefBook === true && !tokenHasExpired();
  } catch (error) {
    return false;
  }
};

export const canPostOnGBI = () => {
  try {
    const token = localStorage.getItem('jwt');
    if (!token) return false;
    const decoded = decodeJWT(token);
    if (tokenHasExpired(decoded)) return false;
    if (decoded.admin) return true;
    return decoded.canPostOnGBI === true && !tokenHasExpired();
  } catch (error) {
    return false;
  }
};

export const canViewFarmerPages = () => {
  try {
    const token = localStorage.getItem('jwt');
    if (!token) return false;
    const decoded = decodeJWT(token);
    if (tokenHasExpired()) return false;
    if (decoded.admin) return true;
    return decoded.canViewFarmerPages === true && !tokenHasExpired();
  } catch (_) {
    return false;
  }
};

export const getOrgIds = () => {
  try {
    const token = localStorage.getItem('jwt');
    if (!token) return null;
    const decoded = decodeJWT(token);
    if (tokenHasExpired(decoded)) return false;
    return decoded.orgs || [];
  } catch (error) {
    return [];
  };
};

export const getUserFromJwt = () => {
  try {
    const token = localStorage.getItem('jwt');
    if (!token) return false;
    const decoded = decodeJWT(token);
    return decoded;
  } catch (error) {
    return {};
  }
};

export const getUserIdFromJwt = () => {
  try {
    const token = localStorage.getItem('jwt');
    if (!token) return null;
    const decoded = decodeJWT(token);
    return decoded.userId;
  } catch (error) {
    return null;
  }
};
